import { BoxProps } from '@mui/material';
import Product from 'components/Product/Product';
import { Product as ProductType } from 'generated/graphql';
import React from 'react';

type ConsultantCategoryProductListProps = {
    itemBoxProps?: BoxProps;
    products: ProductType[];
};

export function ConsultantCategoryProductList(props: ConsultantCategoryProductListProps) {
    const { products, itemBoxProps } = props;

    const consultantFavourites = products;

    return (
        <>
            {consultantFavourites.map((product) => (
                <Product
                    key={product.id}
                    boxProps={{
                        width: '240px',
                        marginX: 1.5,
                        ...itemBoxProps,
                    }}
                    product={product}
                />
            ))}
        </>
    );
}
